export const en = {
  hero_title1: "Share your ",
  hero_title2: "Expenses",
  hero_title3: ", your ",
  hero_title4: "Notes",
  hero_title7: " and organize ",
  hero_title8: "Polls",
  hero_desc: "Linkeven is the easiest (and coolest) way to stay in control of your group expenses without any hassle. Scan a receipt or a payment screen? Our AI automatically identifies the amount and puts it in the right place. Whether it’s for trips, roommates or events, Linkeven is a modern alternative to apps like Tricount or Splitwise for expense sharing. The result: you enjoy the moment, we take care of the numbers ✨",
  btn_start: "Get Started",
  ScanTitle: "Smart Receipt Scan",
  ScanText: "Take a photo of your receipt or payment screen: our AI automatically analyzes and extracts your expense details in a flash.",
  ExpenseFeatureTitle: "Advanced Expense Management",
  ExpenseFeatureText: "Create groups, add unlimited expenses, split amounts however you like, and keep a clear view of who owes what.",
  NoteTitle: "Shared Notes",
  NoteText: "An integrated collaborative notepad for your grocery lists, travel to-dos, useful numbers, and all important info.",
  SurveyTitle: "Polls",
  SurveyText: "Create polls to pick a date, a restaurant, or an activity, and let the group vote directly within the app.",
  DevisesTitle: "Multi-currency & Auto Conversion",
  DevisesText: "Over 170 currencies available (including BTC), with automatic daily exchange rate conversion to simplify trips abroad.",
  StatTitle: "Statistics",
  StatText: "Visualize who spends the most, the balance of payments, and the overall evolution of the group budget.",
  whyLinkount: "Why choose Linkeven ?",
  planetickets: "Plane tickets",
  paidBy: "paid by ",
  me: "Me",
  september: "September",
  karting: "karting",
  boat: "Boat",
  devise: "£",
  shoppinglist: "Shopping list",
  chips: "Chips",
  pasta: "Pasta",
  steak: "Steak",
  beers: "Beers",
  restaurantIdeas: "Restaurant ideas",
  restau1: "The Daily Grill",
  restau2: "Corner Kitchen",
  restau3: "Pizza Project",
  reminder: "Reminder",
  sunscreen: "Sunscreen",
  bugspray: "Bug spray",
  playingcards: "Playing cards",
  excursions: "Excursions",
  boatday: "Boat trip",
  castlevisit: "Castle visit",
  hiking: "Mountain hiking",
  whichRestau: "Which restaurant for Tuesday night?",
  votes1: "1 vote(s)",
  votes2: "0 vote(s)",
  owes: "owes",
  to: "to",
  addExpense: "Unlimited expense entries",
  statExpense: "Expense statistics",
  addTicket: "Add via receipt photo",
  calculdebt: "Debt calculation in all currencies",
  shareNote: "Shared notes (collaborative notepad)",
  pool: "Internal polls / voting",
  agenda: "Integrated calendar / planner",
  multiDevise: "Multi-currency",
  conversion: "Automatic daily rate conversion",
  Devises: "Over 170 currencies including BTC",
  codeRedirectTitle: "Join Linkeven",
  codeRedirectInstalled: "If you already have the app installed, it will open automatically.",
  codeRedirectDownload: "Otherwise, download it directly from the Store.",
  codeRedirectButton: "Download the app"
};